import { useNavigate, useParams } from "react-router-dom";
import { useEditPost } from "../hooks/useEditPost";
import { useEditPostReply } from "../hooks/useEditPostReply";
import { useEffect, useState } from "react";
import BoardReplyEditRow from "../detail/BoardReplyEditRow";
import BoardReplyCreateRow from "./BoardReplyCreateRow";
import { useUser } from "../../../../util/userContext/UserContext";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";

export default function BoardDetail() {
    const { id } = useParams();
    const navigate = useNavigate();

    const { user } = useUser();
    const { inputData, setInputData } = useEditPost();
    const { deletePostReply } = useEditPostReply({ postId: id ?? '' });
    const [editRowKeyArr, setEditRowKeyArr] = useState<string[]>([]);

    useEffect(() => {
        if (inputData?.userId && user?.userId) {
            if (inputData.userId !== user.userId) {
                alert("잘못된 접근입니다.");
                navigate(`${process.env.PUBLIC_URL}/support/board/list`, { replace: true });
            }
        }
    }, [id, user]);

    if (!id) {
        alert("잘못된 접근입니다.");
        navigate(`${process.env.PUBLIC_URL}/support/board/list`, { replace: true });
        return <></>;
    }

    const addEditRowKey = (key: string) => {
        if (!editRowKeyArr.includes(key))
            setEditRowKeyArr([...editRowKeyArr, key]);
    }

    const removeEditRowKey = (key: string) => {
        setEditRowKeyArr(editRowKeyArr.filter((item) => item !== key));
        if (key === '') {
            setInputData((prev: any) => ({
                ...prev,
                replyList: prev.replyList.filter((reply: any) => reply.postReplyId !== key)
            }));
        }
    }

    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">게시판 상세보기</h3>
                    <div className="filter_toolbar">
                        <button
                            className="btn btn-outline-primary w-100px h-38px"
                            onClick={() => navigate(-1)}>
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />
                            목록
                        </button>
                        <AuthorityChecker authorityNames={['boardWriteYn']}>
                            <button
                                className="btn btn-secondary w-100px h-38px"
                                onClick={() => navigate(`${process.env.PUBLIC_URL}/support/board/update/${id}`, { replace: true })}>
                                수정
                            </button>
                        </AuthorityChecker>
                    </div>
                </div>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                            <tr>
                                <th style={{ width: "12.5%" }}>제목</th>
                                <td>{inputData?.title || ''}</td>
                            </tr>
                            <tr>
                                <th>작성자/등록일</th>
                                <td>{inputData?.userName} | {inputData?.regAt}</td>
                            </tr>
                            <tr style={{ height: "249px" }}>
                                <th>내용</th>
                                <td style={{ verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: inputData?.body }}></td>
                            </tr>
                            <tr>
                                <th>첨부파일</th>
                                <td>
                                    <div className="tbl_files_outer">
                                        {inputData?.fileVOList.length !== 0 && <ul className="list_files">
                                            {inputData?.fileVOList.map((item: any) => <li>
                                                <a href={encodeURI(`${process.env.REACT_APP_SERVER_URL}api/customer/support/download_support_file?fileKey=${item.fileKey}&fileOrgname=${item.fileOrgname}&fileUrl=${item.fileUrl}`)}>
                                                    {item.fileOrgname}
                                                </a>
                                            </li>)}
                                        </ul>}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="content_wrap">
                <h3 className="comment_heading">답변</h3>
                <AuthorityChecker authorityNames={['boardWriteYn']}>
                    <button className="btn btn-dark w-100px"
                        onClick={() => {
                            addEditRowKey(''); // 고유 키 추가
                            setInputData((prev: any) => {
                                const newOneExist = (prev?.replyList ?? []).filter((reply: any) => reply.postReplyId === '');
                                if (newOneExist.length === 0)
                                    return ({
                                        ...prev,
                                        replyList: [...prev.replyList, {
                                            postReplyId: '',
                                            isMain: (inputData?.replyList ?? []).filter((reply: any) => reply.isMain === 'Y').length === 0 ? 'Y' : 'N',
                                            postId: id
                                        }]
                                    })
                                else return prev;
                            });
                        }}>
                        답변달기
                    </button>
                </AuthorityChecker>

                {(inputData?.replyList ?? []).map((item: any) => !editRowKeyArr.includes(item.postReplyId) ?
                    <div className="comment_item">
                        <div className="comment_top">
                            <div className="user_detail">
                                <div>
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_user_comment.png"} alt="" />
                                </div>
                                <div>
                                    {item.userName}<br />
                                    {item.regAt}
                                </div>
                            </div>
                            <div className="d-flex justify-content-end mt-15px">
                                <AuthorityChecker authorityNames={['boardWriteYn']}>
                                    {item.userId === user?.userId &&
                                        <a className="me-5px" onClick={() => addEditRowKey(item.postReplyId)}><img
                                            src={process.env.PUBLIC_URL + "/assets/images/icon_edit_post.png"} alt="" /></a>}
                                    {/* {item.isMain !== 'Y' && item.userId === user?.userId &&
                                        <a className="" onClick={() => deletePostReply(item.postReplyId)}><img
                                            src={process.env.PUBLIC_URL + "/assets/images/icon_delete_post.png"}
                                            alt="" /></a>} */}
                                    {item.userId === user?.userId &&
                                        <a className="" onClick={() => deletePostReply(item.postReplyId)}><img
                                            src={process.env.PUBLIC_URL + "/assets/images/icon_delete_post.png"}
                                            alt="" /></a>}
                                </AuthorityChecker>
                            </div>
                        </div>
                        <div className="comment_detail">
                            <div className="message" dangerouslySetInnerHTML={{ __html: item.body }}></div>
                            {(item?.fileVOList ?? []).length > 0 && <div className="btn_list_files">
                                {item.fileVOList.map((file: any) => <>
                                    <button className="btn btn-outline-secondary"
                                        onClick={() => document.getElementById(`file-${file.fileKey}`)?.click()}>
                                        <a id={`file-${file.fileKey}`}
                                            href={encodeURI(`${process.env.REACT_APP_SERVER_URL}api/customer/support/download_support_file?fileKey=${file.fileKey}&fileOrgname=${file.fileOrgname}&fileUrl=${file.fileUrl}`)}></a>
                                        {file.fileOrgname}&nbsp;
                                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_comment_download.png"}
                                            alt="" />
                                    </button>
                                    &nbsp;
                                </>)}
                            </div>}
                        </div>
                    </div> :
                    item.postReplyId ? <BoardReplyEditRow data={item} onCanceled={removeEditRowKey} postId={id} /> :
                        <BoardReplyCreateRow data={item} onCanceled={removeEditRowKey} postId={id} />)}
            </div>
        </>
    );
}